import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_URL}/potential-hires`;

const createPotentialHire = async (data) => {
  const { data: hire } = await axios.post(BASE, data);
  return { hire };
};

const updatePotentialHire = async (id, data) => {
  const { data: hire } = await axios.put(`${BASE}/${id}`, data);
  return { hire };
};

const deletePotentialHire = async (id) => {
  const { data: hire } = await axios.delete(`${BASE}/${id}`);
  return { hire };
};

const emailPotentialHires = async ({ ids, subject, content }) => {
  const { data } = await axios.post(`${BASE}/email`, { ids, subject, content });
  return data;
};

const potentialHireService = {
  createPotentialHire,
  updatePotentialHire,
  deletePotentialHire,
  emailPotentialHires
};

export default potentialHireService;
